import { render } from "./BurnupChart.vue?vue&type=template&id=cd34f40a"
import script from "./BurnupChart.vue?vue&type=script&lang=js"
export * from "./BurnupChart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__